import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * Sets the browser/document title to `CM - <Page>` based on the active route's
 * `title` property. Routes without a title fall back to plain `CM`.
 */
@Injectable({ providedIn: 'root' })
export class CmTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) { super(); }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const page = this.buildTitle(snapshot);
    this.title.setTitle(page ? `CM - ${page}` : 'CM');
  }
}
